export class SetIamApprover {
    public static readonly type = '[Root State] Set i am approver status';

    constructor(public status: boolean) { }
}
